"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_material_1 = require("@mui/icons-material");
var material_1 = require("@mui/material");
var yup_1 = require("@hookform/resolvers/yup");
var react_hook_form_1 = require("react-hook-form");
var yup = __importStar(require("yup"));
var DialogComponent_1 = __importDefault(require("../../components/DialogComponent"));
var ButtomComponent_1 = __importDefault(require("../../components/Form/ButtomComponent"));
var ModalRechargeBalanceContainer_styled_1 = require("./ModalRechargeBalanceContainer.styled");
var utilities_1 = require("../../utilities");
var react_toastify_1 = require("react-toastify");
var date_fns_1 = require("date-fns");
var react_query_1 = require("react-query");
var services_1 = require("../../services");
var react_1 = require("react");
var constants_1 = require("../../constants");
var context_1 = require("../../context");
var schema = yup
    .object({
    balance: yup
        .number()
        .positive('El saldo debe ser un número positivo')
        .integer('El saldo debe ser un número intero')
        .required('El saldo es obligatoria')
        .min(1, 'El saldo debe ser mayor a cero'),
    currency_code: yup.string().required('El tipo de moneda es obligatorio'),
    reference: yup
        .string()
        .required('La referencia es obligatoria')
        .max(255, 'La referencia no debe ser mayor que 255 caracteres'),
    transaction_date: yup
        .date()
        .required('La fecha y hora de transacción es obligatoria')
        .min((0, date_fns_1.subDays)(new Date(), 90), 'La fecha y hora de transacción debe ser mayor')
        .max((0, date_fns_1.addDays)(new Date(), 1), 'La fecha y hora de transacción debe ser menor'),
})
    .required();
function ModalRechargeBalanceContainer(_a) {
    var _b, _c, _d, _e;
    var onClose = _a.onClose, open = _a.open, wallet = _a.wallet;
    var _f = (0, context_1.useGlobalLoading)(), updateLoading = _f.updateLoading, resetLoading = _f.resetLoading;
    var dateTimeNow = (0, utilities_1.nowDateFormat)({
        formatTypeDate: 'yyyy-MM-dd,HH:mm',
    }).replace(',', 'T');
    var minDateTime = (0, utilities_1.getDateBeforeCurrentDate)({
        formatTypeDate: 'yyyy-MM-dd,HH:mm',
        days: 90,
    }).replace(',', 'T');
    (0, react_1.useEffect)(function () {
        if (!wallet) {
            handleCancel();
        }
    }, [wallet]);
    var _g = (0, react_hook_form_1.useForm)({
        resolver: (0, yup_1.yupResolver)(schema),
        defaultValues: {
            balance: 0,
        },
        mode: 'onBlur',
    }), register = _g.register, handleSubmit = _g.handleSubmit, errors = _g.formState.errors, control = _g.control, watch = _g.watch;
    var rechargeBalanceMutation = (0, react_query_1.useMutation)(function (data) {
        return services_1.api.post("/api/v1/merchants/wallets/".concat(wallet.id, "/deposit"), data);
    });
    var onSubmit = function (_a) {
        var transaction_date = _a.transaction_date, reference = _a.reference, data = __rest(_a, ["transaction_date", "reference"]);
        updateLoading(true);
        var date = (0, utilities_1.formatDate)({
            date: transaction_date,
            formatTypeDate: 'dd-MM-yyyy HH:mm:ss',
        });
        rechargeBalanceMutation.mutate({
            merchant_id: wallet.merchant_id,
            transaction_description: "".concat(date, " | ").concat(reference),
            transaction_amount: data.balance,
            currency_code: data.currency_code,
        }, {
            onSuccess: function (data) {
                if (data) {
                    services_1.queryClient.invalidateQueries(constants_1.GET_DETAIL_MERCHANT);
                    services_1.queryClient.invalidateQueries(constants_1.GET_WALLETS_BY_MERCHANT_ID);
                    services_1.queryClient.invalidateQueries(constants_1.GET_TRANSACTIONS_BY_WALLET_ID);
                    react_toastify_1.toast.success('El saldo del cliente B2B fue recargado con éxito');
                    resetLoading();
                    onClose();
                }
            },
            onError: function (error) {
                resetLoading();
                (0, utilities_1.handleError)(error);
            },
        });
    };
    var handleCancel = function () {
        onClose();
    };
    return ((0, jsx_runtime_1.jsxs)(DialogComponent_1.default, __assign({ fullWidth: true, onClose: onClose, open: open }, { children: [(0, jsx_runtime_1.jsxs)(ModalRechargeBalanceContainer_styled_1.HeaderContent, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h6", component: 'h6' }, { children: "Recargar Saldo" })), (0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ onClick: onClose }, { children: (0, jsx_runtime_1.jsx)(icons_material_1.Close, { fontSize: "inherit" }) }))] }), (0, jsx_runtime_1.jsx)(material_1.Divider, {}), (0, jsx_runtime_1.jsx)(ModalRechargeBalanceContainer_styled_1.ContentWrapper, { children: (0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit(onSubmit) }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: { display: 'grid', gap: '20px' } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ sx: { minWidth: 120 }, error: !!errors.currency_code }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, __assign({ id: "select_currency" }, { children: "Tipo de Moneda" })), (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { render: function (_a) {
                                                var field = _a.field;
                                                return ((0, jsx_runtime_1.jsx)(material_1.Select, __assign({ labelId: "select_currency", id: "select_currency", label: "Tipo de Moneda" }, field, { children: (0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: 'PEN' }, { children: "Soles" })) })));
                                            }, name: "currency_code", control: control, defaultValue: "PEN" }), errors.currency_code && ((0, jsx_runtime_1.jsx)(material_1.FormHelperText, { children: (_b = errors.currency_code) === null || _b === void 0 ? void 0 : _b.message }))] })), (0, jsx_runtime_1.jsx)(material_1.TextField, __assign({ label: "Saldo", variant: "outlined", type: "number" }, register('balance'), { error: !!errors.balance, helperText: (_c = errors.balance) === null || _c === void 0 ? void 0 : _c.message, inputProps: { min: 0 } })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: { width: '100%' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.TextField, __assign({ label: "Referencia", variant: "outlined" }, register('reference'), { error: !!errors.reference, helperText: (_d = errors.reference) === null || _d === void 0 ? void 0 : _d.message, multiline: true, rows: 2, fullWidth: true, inputProps: { max: 255 } })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                fontSize: '13px',
                                            } }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ style: { color: 'rgba(0 0 0 / 0.7)' } }, { children: "Cantidad de caracteres" })), ' ', (0, jsx_runtime_1.jsxs)("span", __assign({ style: { fontWeight: 'bold' } }, { children: [(_e = watch('reference', false).length) !== null && _e !== void 0 ? _e : 0, "/255"] }))] }))] })), (0, jsx_runtime_1.jsx)(material_1.FormControl, __assign({ sx: { minWidth: 120 } }, { children: (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { render: function (_a) {
                                            var _b;
                                            var field = _a.field;
                                            return ((0, jsx_runtime_1.jsx)(material_1.TextField, __assign({ label: "Fecha y Hora de Transacci\u00F3n", variant: "outlined", type: "datetime-local" }, field, { error: !!errors.transaction_date, helperText: (_b = errors.transaction_date) === null || _b === void 0 ? void 0 : _b.message, inputProps: { min: minDateTime, max: dateTimeNow } })));
                                        }, name: "transaction_date", control: control, defaultValue: dateTimeNow }) }))] })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                                marginTop: '20px',
                                display: 'flex',
                                gap: '10px',
                                justifyContent: 'flex-end',
                            } }, { children: [(0, jsx_runtime_1.jsx)(ButtomComponent_1.default.Filter, __assign({ style: { textTransform: 'uppercase' }, onClick: handleCancel, variant: "outlined", color: "inherit" }, { children: "Cancelar" })), (0, jsx_runtime_1.jsx)(ButtomComponent_1.default, __assign({ variant: "contained", type: "submit" }, { children: rechargeBalanceMutation.isLoading ? 'Recargando...' : 'Recargar' }))] }))] })) })] })));
}
exports.default = ModalRechargeBalanceContainer;
